import { LOGO_TYPE_MNEMONIC } from 'page/home/types'
export const LOGO_TYPE = {
    [LOGO_TYPE_MNEMONIC.LIGA]                  : 'liga',
    [LOGO_TYPE_MNEMONIC.OSCARYARD_RUBLEVKA]    : 'oscaryard-rublevka',
    [LOGO_TYPE_MNEMONIC.OSCARYARD_KOSMOS]      : 'oscaryard-kosmos',
    [LOGO_TYPE_MNEMONIC.OSCARYARD_PUSHKINSKAYA]: 'oscaryard-pushkinskaya',
    [LOGO_TYPE_MNEMONIC.WITHOUT]               : ''
};



// WEBPACK FOOTER //
// ./src/blocks/tasks/types.js